jQuery(document).ready( function ($) {
    $('.js-return-link').on('click', function (event){
        if ( document.referrer !== '' ) {
            event.preventDefault();
            window.history.back();
        }
        // if ( document.referrer.includes('index.html') || document.referrer.includes('mencion') ) {
        // }
    });
});